export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00154.7a565ad0.png";